export const loginRouterPath = '/login'
export const TREELESS_SESSION_ROUTE = 'treeless/session/:sessionId'
export const SESSION_ROUTE = 'project/:projectId/treeId/:treeId'
export const SESSION_ROUTE_EXTERNAL =
  '/external/project/:projectId/treeId/:treeId'
export const SESSION_ROUTE_EXTERNAL_LEGACY =
  '/external/line/:projectId/treeId/:treeId'
